const VERSION = '2.0.19b'
export default VERSION
